const TAG_MUTATION_TYPES = Object.freeze({
  FETCH_DATA_TAG_LIST: 'FETCH_DATA_TAG_LIST',
  SET_TAG_LIST: 'SET_TAG_LIST',
  SET_ERROR: 'SET_ERROR',
});

export default TAG_MUTATION_TYPES;
